import React from "react";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";

const CampaignErrorModal: React.FC<ModalProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    return (
        <CommonModal
            visible={open}
            confirmText="Try again"
            cancelText="Close"
            background="#FBEAEA"
            iconType={'campaignError'}
            modalContentTitle={"Something went wrong"}
            modalContentDesc={[
                "We couldn’t create your campaign due to a temporary issue.",
                "The campaign was not created and no emails were sent.",
                "Please try again. If the problem continues, contact the Customer Success Team for assistance."
            ]}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default CampaignErrorModal;